export const getPractitionerDummyDocIdForSpecialtyType = specialtyType => {
	switch (specialtyType) {
		case 'PT':
			return '1216105';
		case 'OT':
			return '1216106';
		default:
			return undefined;
	}
};
